import { Component, Input, NgModule, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterStaticLinkDirectiveModule } from '@icilalune/utils';
import { MainMenuTreeItem } from '@nx-icilalune/data/icilalune/types';
import { TreeItem } from '@nx-icilalune/drupal-types';

@Component({
  selector: 'i2l-ui-section-menu-items',
  template: `
    <ng-container *ngIf="label">
      <span class="menu-caption" [innerHTML]="label"></span>
    </ng-container>
    <ng-container *ngIf="menuItems && menuItems.length > 1">
      <ul class="b-menu">
        <ng-template ngFor [ngForOf]="menuItems" let-menuItem>
          <ng-container *ngIf="menuItem">
            <li>
              <a
                [routerStaticLink]="menuItem.path"
                [style.--linkColor]="
                  'var(--lune-color-section-' + menuItem['color'] + '-default)'
                "
                [style.--linkColor-light]="
                  'var(--lune-color-section-' + menuItem['color'] + '-light)'
                "
              >
                <span [innerHTML]="menuItem.title"></span>
              </a>
            </li>
          </ng-container>
        </ng-template>
      </ul>
    </ng-container>
  `,
  styleUrls: ['./section-menu-items.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class SectionMenuItemsComponent {
  @Input()
  label!: string;

  @Input()
  menuItems!: TreeItem<MainMenuTreeItem>[] | undefined;
}

@NgModule({
  imports: [CommonModule, RouterStaticLinkDirectiveModule],
  declarations: [SectionMenuItemsComponent],
  exports: [SectionMenuItemsComponent],
})
export class SectionMenuItemsComponentModule {}
